import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "items-sorting-container"
};
const _hoisted_2 = ["draggable", "onDragstart", "onDragenter", "onDrop"];
const _hoisted_3 = {
  class: "item-order-number"
};
const _hoisted_4 = {
  class: "reorder-icon-container"
};
const _hoisted_5 = {
  class: "item-value-container"
};
const _hoisted_6 = {
  class: "item-image-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_question_answer_image_uploader = _resolveComponent("question-answer-image-uploader");
  const _component_w_input = _resolveComponent("w-input");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realtimeSortingItems, (sortingItem, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: sortingItem.position,
      class: _normalizeClass(['sorting-item', {
        'is-drag-over': index === _ctx.dragOverIndex
      }]),
      onMousedown: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.handleMouseDown && _ctx.handleMouseDown(...args)),
      draggable: _ctx.isDraggable,
      onDragstart: $event => _ctx.onDragStart(index),
      onDragenter: _withModifiers($event => _ctx.onDragEnter(index), ["prevent"]),
      onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _withModifiers($event => _ctx.onDrop(index), ["prevent"]),
      onDragend: _cache[2] || (_cache[2] =
      //@ts-ignore
      (...args) => _ctx.onDragEnd && _ctx.onDragEnd(...args))
    }, [_createElementVNode("span", _hoisted_3, _toDisplayString(sortingItem.position), 1), _createElementVNode("span", _hoisted_4, [_createVNode(_component_icon, {
      class: "reorder-icon",
      icon: "drag-vertical"
    })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_question_answer_image_uploader, {
      image: sortingItem.image,
      onImageUploaded: $event => _ctx.onAnswerImageChange($event, sortingItem),
      onImageDelete: $event => _ctx.onImageDelete(sortingItem)
    }, null, 8, ["image", "onImageUploaded", "onImageDelete"])]), _createVNode(_component_w_input, {
      class: _normalizeClass(['item-input', {
        'is-error': sortingItem.isValueError
      }]),
      value: sortingItem.image ? sortingItem.image.imageLabel : sortingItem.value,
      type: 'text',
      placeholder: _ctx.$t('chapter.question.sorting.itemPlaceholder'),
      maxlength: _ctx.LABEL_NB_MAX_CHARS,
      onInputBlur: $event => _ctx.onSortingItemBlur(sortingItem, $event)
    }, null, 8, ["class", "value", "placeholder", "maxlength", "onInputBlur"])]), _createVNode(_component_icon, {
      class: "item-delete-icon",
      icon: "delete-outline",
      disabled: _ctx.realtimeSortingItems.length <= 2,
      onClick: $event => _ctx.deleteItem(sortingItem)
    }, null, 8, ["disabled", "onClick"])], 42, _hoisted_2);
  }), 128)), _createVNode(_component_confirm_dialog, {
    "v-if": _ctx.activeItem && _ctx.displayItemDeletionDialog,
    visible: _ctx.displayItemDeletionDialog,
    title: _ctx.$t('chapter.question.sorting.deleteItem.modal.title'),
    message: _ctx.$t('chapter.question.sorting.deleteItem.modal.description'),
    "confirm-button-text": _ctx.$t('chapter.question.sorting.deleteItem.modal.validateBtn'),
    "cancel-button-text": _ctx.$t('chapter.question.sorting.deleteItem.modal.cancelBtn'),
    "close-on-outside-click": false,
    onOnConfirmed: _cache[3] || (_cache[3] = $event => _ctx.onItemDeleteConfirm()),
    onOnDialogClose: _cache[4] || (_cache[4] = $event => _ctx.onItemDeleteCancel()),
    onOnCanceled: _cache[5] || (_cache[5] = $event => _ctx.onItemDeleteCancel())
  }, null, 8, ["v-if", "visible", "title", "message", "confirm-button-text", "cancel-button-text"])]);
}